import { observer } from 'mobx-react';
import * as React from 'react';
import GroupParticipantsStore from '../../../Group/GroupParticipantsStore/Store';
import { GroupParticipantsResource } from '../../../Group/GroupParticipantsStore/Types';
import AddParticipantStore from '../../Store';
import ModalState from './ModalState';

export interface Props {
  store: AddParticipantStore;
  groupParticipantsResource: GroupParticipantsResource;
  groupParticipantsStore: GroupParticipantsStore;
}

const ParticipantsAddedModal: React.FC<Props> = ({
  store,
  groupParticipantsResource,
  groupParticipantsStore,
}) => {
  switch (store.state.kind) {
    case 'ready':
    case 'submitting':
    case 'new-participant':
    case 'error':
    case 'remove-participant':
      return <></>;
    case 'participants-added':
      return (
        <ModalState
          store={store}
          groupParticipantsResource={groupParticipantsResource}
          groupParticipantsStore={groupParticipantsStore}
          participantsAdded={store.state.participantsAdded}
        />
      );
  }
};

export default observer(ParticipantsAddedModal);
